import { useEffect } from "react";
import "@/App.css";

// This project is a standalone Node/Express + Playwright app located in
// /app/smarttag-monitor. The React scaffold is only used here to host the
// dashboard preview: it immediately redirects to the static dashboard page.
function App() {
  useEffect(() => {
    window.location.replace("/dashboard.html");
  }, []);

  return (
    <div style={{ background: "#0b0f14", color: "#8595a4", minHeight: "100vh",
      display: "flex", alignItems: "center", justifyContent: "center",
      fontFamily: "system-ui, sans-serif" }}>
      Loading Samsung SmartTag Monitor…
    </div>
  );
}

export default App;
